"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._SelfServiceFittecWrappedReferences = void 0;
exports._SelfServiceFittecWrappedReferences = {
    fittecWrappedContainer: {
        required: false,
        uid: 'fittec-wrapped',
        dontRemoveFromDom: true,
        description: 'Optional wrapped container. Existing ci-story-cards content is preserved; empty or missing story cards use the default HTML stories. data-get supports year, companyName, checkins, averageTrainingDurationMinutes, minutesSpent, hoursSpent, courseCategoryCount, courseVisits, courseVisitsByCategory.0.category, courseVisitsByCategory.0.visits, favoriteCourse.name, favoriteCourse.visits, topPercentInClub, and topPercentInCompany.',
    },
};
